import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/show_process/${packing_house_process_id}`
    );
  },
  fetchContainer(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/show_container/${packing_house_process_id}/${container_id}`
    );
  },
  fetchPackingListFormats(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/show_container/${packing_house_process_id}/fetch_packing_list_formats/${container_id}`
    );
  },
  downloadPackingListXlsx(packing_house_process_id, container_id, packing_list_format_id) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/show_container/${packing_house_process_id}/download_packing_list_xlsx/${container_id}/${packing_list_format_id}`,
      { responseType: "blob" }
    );
  },
  fetchPackages(packing_house_process_id, container_id) {
    return RequesterV1.get(
      `packing_house/production/final_packing_list_simplified/show_container/${packing_house_process_id}/fetch_packages/${container_id}`
    );
  }
};
